import punycode from 'punycode';

const pcEncode = value => punycode.encode(value);
const pcToUnicode = value => punycode.toUnicode(value);
const pcToASCII = value => punycode.toASCII(value);
const pcDecode = value => {
  let output = [];
  let nonCodablePart = false;
  let lines = value.match(/[^\n,]+/gim);

  for (let i = 0; i < lines.length; i++) {
    lines[i].replace(/((?:https?:\/\/)?[^\/]+)(\/.*)?/, '$1, $2');
    let codablePart = RegExp.$1;
    RegExp.$2 != '' ? (nonCodablePart = RegExp.$2) : (nonCodablePart = false);
    let sections = codablePart.match(/[^\.\/]+/gim);
    let separators = codablePart.match(/[\.\/]+/gim);
    output[i] = '';
    for (let j = 0; j < sections.length; j++) {
      sections[j].match(/xn\-\-/) ? (output[i] += punycode.toUnicode(sections[j])) : (output[i] += sections[j]);
      if (separators && typeof separators[j] !== 'undefined') {
        output[i] += separators[j];
      }
    }
    if (nonCodablePart) {
      output[i] += nonCodablePart;
    }
  }
  return output.join('\n');
};

export { pcDecode, pcEncode, pcToUnicode, pcToASCII };



// WEBPACK FOOTER //
// ./src/tools/punycode.js